import { useLayoutEffect, useState } from 'react';

/** A short gap between chunks is normal; longer silence needs feedback. */
export const RESPONSE_PAUSE_MS = 3000;

export function useResponseWaiting(isStreaming: boolean, content: string): boolean {
  const [waiting, setWaiting] = useState(isStreaming && !content.trim());

  useLayoutEffect(() => {
    const empty = !content.trim();

    // Update before paint so a resumed stream never flashes its old ring.
    setWaiting(isStreaming && empty);
    if (!isStreaming || empty) return undefined;
    const timeout = setTimeout(() => setWaiting(true), RESPONSE_PAUSE_MS);

    return () => clearTimeout(timeout);
  }, [isStreaming, content]);

  return isStreaming && waiting;
}
